module.exports = "/_next/static/images/BlockDataCollection@2x-865a3153cc2e23ceeadb8e455252f485.webp";